import { configureStore, Reducer, Action, ThunkAction } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import logger from 'redux-logger'

import dashboard, { DashboardState } from './slices/dashboard'
import live_tips, { LiveTipsState } from './slices/live-tips'
import settings, { SettingsState } from './slices/settings'
import fixtures, { FixturesState } from './slices/fixtures'
import account, { AccountState } from "./slices/account"

// Configure store with reducers and middleware (redux-logger)
export const store = configureStore({
    reducer: {
        dashboard: dashboard as Reducer<DashboardState>,
        live_tips: live_tips as Reducer<LiveTipsState>,
        settings: settings as Reducer<SettingsState>,
        fixtures: fixtures as Reducer<FixturesState>,
        account: account as Reducer<AccountState>,
    },
    middleware: (getDefaultMiddleware) => {
        if (process.env.NODE_ENV === 'development') {
            return getDefaultMiddleware().concat(logger); // Add logger middleware here
        }

        return getDefaultMiddleware();
    } // Add logger middleware here
});

// Define types for AppDispatch and RootState
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
